import { SCORING } from '@/config/scoring';

export interface GameState {
  score: number;
  lives: number;
  level: number;
  dotsEaten: number;
  totalDots: number;
  ghostCombo: number;
  extraLifeAwarded: boolean;
  collectedFruits: string[];
}

export function createInitialGameState(): GameState {
  return {
    score: 0,
    lives: SCORING.STARTING_LIVES,
    level: 1,
    dotsEaten: 0,
    totalDots: 0,
    ghostCombo: 0,
    extraLifeAwarded: false,
    collectedFruits: [],
  };
}
